import {addDurations, parseHourMinute} from "../../utils/datetimeUtils"
const WaitTime = ({avg="00:00", buffer="00:10", label="Ready in"}) => {
    const avgTime = parseHourMinute(avg)
    let avgTimeLabel = avgTime.days > 0 ? `${avgTime.days} day(s)`:
                         avgTime.hrs > 0 ? `${avgTime.hrs} hr${avgTime.hrs > 1 ? "s" : ""}` :
                         `${avgTime.mins}`
    const bufferTime = parseHourMinute(addDurations(avg, buffer))
    const bufferTimeLabel = bufferTime.days > 0 ? "":
                            bufferTime.hrs > 0 ? `${bufferTime.hrs} ${bufferTime.mins > 0 ? `hr${bufferTime.hrs > 1 ? "s" : ""} ${bufferTime.mins} mins`: `hr${bufferTime.hrs > 1 ? "s" : ""}`}` :
                         `${bufferTime.mins} mins`
    //tack on mins to the avg time label if it has no hrs, but the buffer time does
    avgTimeLabel = avgTime.hrs === 0 && avgTime.days === 0 && bufferTime.hrs > 0 ?
                    `${avgTimeLabel} mins`
                    :
                    avgTimeLabel
    return (
        `${label ? `${label} ` : ""}${avgTimeLabel}${bufferTimeLabel ? ` - ${bufferTimeLabel}` : ""}`
    )
}

export default WaitTime